import Timeline from 'components/atoms/timeline';
import ExperienceDetailsProvider, { CompanyLinkedInId, useExperienceDetailsContext } from 'context/experience-details';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SectionWithTwoLevelList from 'components/organisms/section/sectionWithTwoLevelList';
import EXPERIENCE_DETAILS from './constants/ConstExperienceDetails';

function Experience() {
  const { id, setId } = useExperienceDetailsContext();

  const { search, pathname } = useLocation();
  const navigate = useNavigate(); // Use navigate to modify the URL
  const query = new URLSearchParams(search);
  const existingCompanyLinkedInId = query.get('company');

  useEffect(() => {
    if (existingCompanyLinkedInId) {
      // Set the ID in the context
      setId(existingCompanyLinkedInId as CompanyLinkedInId);

      // Remove 'company' param from the URL after setting it in the state
      query.delete('company');
      navigate(
        {
          pathname,
          search: query.toString(), // Updated query string without 'company'
        },
        { replace: true },
      ); // Replace the current entry in history to prevent navigation
    }
  }, [existingCompanyLinkedInId, pathname, query, navigate, setId]);

  return id ? (
    <SectionWithTwoLevelList
      onBackButtonClick={() => setId(undefined)}
      title={`My experience in ${EXPERIENCE_DETAILS?.[id]?.title}`}
      items={EXPERIENCE_DETAILS[id]?.items}
    />
  ) : (
    <Timeline
      events={[
        {
          date: 'Nov 2022 - Present',
          title: 'Frontend Engineer',
          company: EXPERIENCE_DETAILS?.['e-butler']?.title,
          companyUrl: 'https://www.linkedin.com/company/e-butler',
          badges: ['Full Time', 'Remotely'],
          onMoreInfoClick: () => setId('e-butler'),
        },
        {
          date: 'Dec 2020 - Nov 2022',
          title: 'Full Stack Engineer',
          company: EXPERIENCE_DETAILS?.['hassan-allam-holding']?.title,
          companyUrl: 'https://www.linkedin.com/company/hassan-allam-holding/',
          badges: ['Full Time', 'On Site'],
          // onMoreInfoClick: () => setId('hassan-allam-holding'),
        },
        {
          date: 'Jun 2019 - Jul 2019',
          title: 'Oracle Database Administrator',
          company: EXPERIENCE_DETAILS?.['orascom-construction-plc']?.title,
          companyUrl: 'https://www.linkedin.com/company/orascom-construction-plc/',
          badges: ['Internship'],
          dashedLine: true,
          // onMoreInfoClick: () => setId('orascom-construction-plc'),
        },
        {
          date: 'Jul 2018 - Sep 2018',
          title: 'Software Quality Assurance Engineer',
          company: EXPERIENCE_DETAILS?.['4s-technology']?.title,
          companyUrl: 'https://www.linkedin.com/company/4s-technology/',
          badges: ['Internship'],
          dashedLine: true,
          // onMoreInfoClick: () => setId('4s-technology'),
        },
      ]}
    />
  );
}

export default function ExperienceWrapper() {
  return (
    <ExperienceDetailsProvider>
      <Experience />
    </ExperienceDetailsProvider>
  );
}
